module.exports = __webpack_public_path__ + "static/media/OPN_500.6c62f62e.png";